export default __webpack_public_path__ + "static/media/icon_4.665c203e.png";